export default __webpack_public_path__ + "static/media/greenStepCompleted.49f2b676.svg";